import { makeStyles } from "@fluentui/react-components";

//-------------------------------------------------------------------------------------------------------
// Class names used in Icon components
//-------------------------------------------------------------------------------------------------------

export const useBaseIconStyles = makeStyles({
  root: {
    display: "inline-block",
    textDecoration: "inherit",
  },

  image: {
    overflow: "hidden",
  },

  defaultIcon: {
    WebkitFontSmoothing: "antialiased",
    display: "inline-block",
    fontStyle: "normal",
    fontWeight: "400",
    speak: "none",
  },
});
